module.exports = __webpack_public_path__ + "img/vip-fill.5c23bd57.svg";